export const POSTHOG_EU_HOST = 'https://eu.i.posthog.com';
export const AUTH_STORAGE_KEY = 'atilum-auth';

export function getSupabaseAuthConfig() {
  return {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: AUTH_STORAGE_KEY,
  };
}
